import { GuardianSimple } from '@dreryk/egabinet-patient-frontend-api';

import { TranslatableText, useTranslate } from '@dreryk/react-common';

import { personalDataTranslationKeys } from '../../../../../../../translations';

import { StyledGuardianCell } from './StyledGuardianCell';
import { StyledGuardianCellGuardianName } from './StyledGuardianCellGuardianName';
import { StyledGuardianCellPesel } from './StyledGuardianCellPesel';

type GuardiansTableGuardianCellProps = Pick<GuardianSimple, 'firstName' | 'lastName' | 'guardianExternalIdentifier'>;

export const GuardianCell = (props: GuardiansTableGuardianCellProps): JSX.Element => {
   const translate = useTranslate();

   const externalIdentifierType = props.guardianExternalIdentifier.accept<TranslatableText>({
      visitPesel: () => personalDataTranslationKeys.identifierType.displayName.Pesel,
      visitPassport: () => personalDataTranslationKeys.identifierType.displayName.Passport,
      visitNationalIdentificationNumber: () =>
         personalDataTranslationKeys.identifierType.displayName.NationalIdentificationNumber,
   });
   const externalIdentifierValue = props.guardianExternalIdentifier.accept<string>({
      visitPesel: (pesel) => pesel.asString(),
      visitPassport: (passport) => passport.getValue(),
      visitNationalIdentificationNumber: (nationalIdentificationNumber) => nationalIdentificationNumber.getValue(),
   });

   return (
      <StyledGuardianCell>
         <StyledGuardianCellGuardianName>
            {props.firstName.asString()} {props.lastName.asString()}
         </StyledGuardianCellGuardianName>
         <StyledGuardianCellPesel>
            {`${translate(externalIdentifierType)}: ${externalIdentifierValue}`}
         </StyledGuardianCellPesel>
      </StyledGuardianCell>
   );
};
